import React, {
    ReactElement,
} from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { Loading } from "../../../../components";
import DisplayTicketState from "../../../../components/creators/ticket-state/TicketState";
import { STATUS_TEXT } from "../../../../components/pickers/chat-status/ChatStatus";
import useRouting, { Link, useParams } from "../../../../contexts/Routing";
import { useGetTicketStatesListQuery } from "../../../../__generated__/api";
import { ErrorRemote } from "../../../error/Error";

function DisplayTicketStateList(): ReactElement {
    const { data, error, loading: isLoading } = useGetTicketStatesListQuery();
    const { Paths } = useRouting();

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <ErrorRemote error={error} />;
    }

    return (
        <div className="d-flex align-items-stretch flex-column">
            <div className="border p-3 rounded bg-white">
                {data?.ticketStates.isNotEmpty ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="text-light mb-0">
                                Columns
                            </h5>

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "new",
                                    setting: "ticket-states",
                                }}
                                className="btn btn-none btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Column
                            </Link>

                        </div>
                        <div className="list-group">
                            {data?.ticketStates
                                .sortBy(ticketState => ticketState.chatStatuses.firstElement?.toLowerCase())
                                .map(ticketState => (
                                    <Link
                                        to={Paths.ADMINISTRATOR_SETTING_ID}
                                        params={{
                                            id: ticketState.id,
                                            setting: "ticket-states",
                                        }}
                                        className={"list-group-item list-group-item-action "
                                        + "align-items-start justify-content-between d-flex"}
                                    >
                                        <div>
                                            <h5>
                                                {ticketState.name}
                                            </h5>
                                            <small>{ticketState.description}</small>
                                        </div>

                                        <div className="d-flex">
                                            {ticketState.chatStatuses.map(state => (
                                                <div className="me-2 badge rounded-pill bg-blue-dark">{STATUS_TEXT[state]}</div>
                                            ))}
                                        </div>

                                    </Link>

                                ))}

                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-3">

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "new",
                                    setting: "ticket-states",
                                }}
                                className="btn btn-secondary btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Column
                            </Link>
                        </div>

                    </>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-light my-4">
                        <h5 className="text-light">
                            Group
                        </h5>
                        <Link
                            to={Paths.ADMINISTRATOR_SETTING_ID}
                            params={{
                                id: "new",
                                setting: "ticket-states",
                            }}
                            className="btn btn-secondary btn-sm my-3"
                        >
                            <AiOutlinePlus />
                            {" "}
                            Add Column
                        </Link>
                        <small>
                            Columns manage which categories or groups an agent is able to view or add to their dashboard.
                        </small>
                    </div>

                )}

            </div>

        </div>
    );
}

export default function TicketStateSettings(): ReactElement {
    const { Paths, historyPush } = useRouting();

    const { id } = useParams(Paths.ADMINISTRATOR_SETTING_ID);
    return id ? (
        <DisplayTicketState
            id={id}
            className="border p-3 rounded mb-4 bg-white"
            onSave={() => {
                historyPush(Paths.ADMINISTRATOR_SETTING, {
                    setting: "ticket-states",
                });
            }}
        />
    ) : <DisplayTicketStateList />;
}
